import { CalendarIcon, dayjs, UserIcon } from '@umanforge/common';
import { RpTaskSearch } from 'interfaces/api_deep_search.interfaces';
import React, { useEffect, useRef, useState } from 'react';
import { BaseCardComponent } from '../baseCard.component';

interface RpCardProps {
  rp: RpTaskSearch;
}

const RpCardComponent: React.FC<RpCardProps> = ( { rp } ) => {

  const descriptionRef = useRef<HTMLSpanElement>( null );

  const [ isCollapsed, setIsCollapsed ] = useState( true );
  const [ isDescriptionClamped, setIsDescriptionClamped ] = useState( false );

  useEffect( () => {
    window.addEventListener( 'resize', updateDescriptionClamped );

    return () => {
      window.removeEventListener( 'resize', updateDescriptionClamped );
    };
  }, [] );

  useEffect( () => {
    updateDescriptionClamped();
  }, [ descriptionRef ] );

  const updateDescriptionClamped = () => {
    let result = false;
    const currentDescriptionRef = descriptionRef.current;
    if ( currentDescriptionRef ) {
      result = currentDescriptionRef.scrollHeight > currentDescriptionRef.clientHeight;
    }
    setIsDescriptionClamped( result );
  };

  return (
    <BaseCardComponent
      id={ String( rp.index ) }
      title={ rp.rpTitle }
      breadcrumb={ `${ rp.clientName } / ${ rp.siteName }` }
      application={ rp.application }
      firstChildren={
        <div className='flex flex-col w-full h-full gap-2.5'>
          <div className='flex gap-4 w-fit items-center text-xs text-gray-700'>
            <div className='flex gap-1 items-center'>
              <UserIcon className='w-3.5 h-3.5'/>
              <span> { rp.piloteFullname } </span>
            </div>
            <div className='flex gap-1 items-center'>
              <CalendarIcon className='w-3.5 h-3.5'/>
              <span> { dayjs( rp.detectedDate ).format( 'L' )} </span>
            </div>
          </div>
          <span
            className={ `text-sm text-gray-900 ${ isDescriptionClamped ? 'cursor-pointer' : '' } ${ isCollapsed ? 'line-clamp-2' : '' }` }
            ref={ descriptionRef }
            onClick={ () => { if ( isDescriptionClamped ) { setIsCollapsed( !isCollapsed ); } } }
          >
            { rp.description }
          </span>
        </div>
      }
    />
  );
};

export { RpCardComponent };
